import { Trpconsignmentinv } from './Trpconsignmentinv';
import { Trpconsignment } from './Trpconsignment';

export class GRBooking {
    public Consignment: Trpconsignment | undefined;
    public ConsignmentInv: Trpconsignmentinv[] = [];
}
